// @flow
import React from 'react'
import classnames from 'classnames'

type PropsT = {
  className?: string,
  fill?: string,
  stroke?: string
}

const IconShare = ({ className, stroke, fill }: PropsT) => (
  <svg className={classnames('Icon IconShare', className)} viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'>
    <title>share</title>
    <g strokeWidth="1" fillRule="evenodd">
        <g id="share-icon" fillRule="nonzero">
            <path d="M12.4041212,19.1971932 C11.7348881,19.7012194 10.902336,20 10,20 C7.790861,20 6,18.209139 6,16 C6,13.790861 7.790861,12 10,12 C11.1777206,12 12.2365626,12.5089795 12.9685582,13.3189707 L18.2041175,10.2648945 C18.0717048,9.86734175 18,9.44204465 18,9 C18,6.790861 19.790861,5 22,5 C24.209139,5 26,6.790861 26,9 C26,11.209139 24.209139,13 22,13 C20.9558903,13 20.0052159,12.5999557 19.2928901,11.9447803 C19.2853486,11.9494484 19.2777241,11.9540313 19.2700172,11.958527 L13.8967164,15.0929524 C13.9642835,15.3843823 14,15.6880201 14,16 C14,16.5714224 13.8801797,17.1148592 13.6642935,17.6065563 L18.9263802,20.4399876 C19.6601199,19.5599986 20.7646626,19 22,19 C24.209139,19 26,20.790861 26,23 C26,25.209139 24.209139,27 22,27 C19.790861,27 18,25.209139 18,23 C18,22.7438054 18.0240855,22.4932362 18.0701157,22.2504333 L12.4598876,19.2295412 C12.4408285,19.2192786 12.4222369,19.2084866 12.4041212,19.1971932 Z M22,11 C23.1045695,11 24,10.1045695 24,9 C24,7.8954305 23.1045695,7 22,7 C20.8954305,7 20,7.8954305 20,9 C20,10.1045695 20.8954305,11 22,11 Z M22,25 C23.1045695,25 24,24.1045695 24,23 C24,21.8954305 23.1045695,21 22,21 C20.8954305,21 20,21.8954305 20,23 C20,24.1045695 20.8954305,25 22,25 Z M10,18 C11.1045695,18 12,17.1045695 12,16 C12,14.8954305 11.1045695,14 10,14 C8.8954305,14 8,14.8954305 8,16 C8,17.1045695 8.8954305,18 10,18 Z"></path>
        </g>
    </g>
  </svg>
)

export default IconShare
